var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3009_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49805 14.3085H1.49887C3.77556 19.906 11.0196 27.5662 17.6427 14.5052C19.6612 10.5247 21.0261 7.64272 22.0127 5.55943C24.2634 0.807049 24.5457 0.210942 26.1285 0.210938C27.9266 0.210933 33.1784 7.09511 35.0428 14.5419C35.0417 14.54 35.0407 14.538 35.0397 14.5362C30.6734 7.79348 28.4459 4.29488 26.4597 4.42727C24.2684 4.57335 22.3707 9.13897 18.2183 18.6438C17.8659 19.2664 17.5347 19.9586 17.2287 20.7247C16.934 21.352 16.6131 22.1698 16.2624 23.0905C16.2092 23.2104 16.1556 23.331 16.1017 23.4522C8.85767 37.7572 2.7399 20.9427 1.49805 14.3085Z",
    fill: "#9E65FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3009_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49829 14.3085H1.49911C3.77581 19.906 11.0198 27.5662 17.6429 14.5052C19.6614 10.5247 21.0263 7.64272 22.0129 5.55943C24.2636 0.807049 24.5459 0.210942 26.1288 0.210938C27.9268 0.210933 33.1786 7.09511 35.043 14.5419C35.042 14.54 35.041 14.538 35.0399 14.5362C30.6736 7.79348 28.4462 4.29488 26.46 4.42727C24.2686 4.57335 22.371 9.13897 18.2185 18.6438C17.8661 19.2664 17.5349 19.9586 17.229 20.7247C16.9343 21.352 16.6133 22.1698 16.2627 23.0905C16.2094 23.2104 16.1558 23.331 16.1019 23.4522C8.85791 37.7572 2.74014 20.9427 1.49829 14.3085Z",
    fill: "url(#paint0_linear_3009_4327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3865 22.7876C16.3327 22.9074 16.1849 22.9227 16.1305 23.0437C8.80863 37.3275 2.71873 20.7066 1.46354 14.0823H0C2.09196 28.573 5.1007 33.5521 9.20463 33.5413C12.2945 33.5331 14.4994 27.7766 16.1143 23.5606C16.2069 23.3187 16.2977 23.0181 16.3865 22.7876Z",
    fill: "url(#paint1_linear_3009_4327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0384 14.539L35.0415 14.5448C35.5766 16.6818 35.8326 18.8652 35.648 20.9455H34.4062C32.0894 14.7571 23.1092 10.0027 18.217 18.6467C22.3695 9.14187 24.2672 4.57621 26.4585 4.43014C28.4447 4.29774 30.6721 7.79634 35.0384 14.539Z",
    fill: "url(#paint2_linear_3009_4327)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.0382 14.539L35.0413 14.5448C35.5763 16.6818 35.8324 18.8652 35.6478 20.9455H34.4059C32.0891 14.7571 23.109 10.0027 18.2168 18.6467C22.3692 9.14187 24.2669 4.57621 26.4582 4.43014C28.4444 4.29774 30.6718 7.79634 35.0382 14.539Z",
    fill: "url(#paint3_linear_3009_4327)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3009_4327",
    x1: 10.878,
    y1: 29.0562,
    x2: 35.2454,
    y2: 11.0925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.665552,
    stopColor: "#6200EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3009_4327",
    x1: 4.09497,
    y1: 30.3356,
    x2: 9.94609,
    y2: 25.4673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.193709,
    stopColor: "#4400A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6200EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3009_4327",
    x1: 36.6572,
    y1: 20.2927,
    x2: 25.3221,
    y2: 6.33146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F55EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#170618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621542,
    stopColor: "#E159E3",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D4B8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3009_4327",
    x1: 35.5896,
    y1: 23.1716,
    x2: 31.0089,
    y2: 3.27215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6200EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806291,
    stopColor: "#4400A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3009_4327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.0132,
    height: 34,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3009_4327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.0132,
    height: 34,
    fill: "white",
    transform: "translate(0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2b8c2991b58a3a4affd83a011db86a96.svg";
export { ForwardRef as ReactComponent };